export default __webpack_public_path__ + "static/media/cr-1.ce750e4f.png";